import { useEffect } from 'react';

import { useBrandTermsActions, useBrandVoicesAssets } from 'src/store';

export const useMaintainBrandRulesData = () => {
  const brandTermsActions = useBrandTermsActions();
  const { loadingBrandVoiceAssets, brandVoicesAssets } = useBrandVoicesAssets();

  useEffect(() => {
    if (loadingBrandVoiceAssets) {
      return;
    }

    const brandVoicesIds = brandVoicesAssets.reduce(
      (acc, item) => {
        if (item.brandTerms.length > 0) {
          acc.withBrandRules.push(item.id);
        }
        acc.all.push(item.id);
        return acc;
      },
      { withBrandRules: [], all: [] }
    );

    if (brandVoicesIds.withBrandRules.length === 0) {
      brandTermsActions.toggleBrandRulesActivity();
      return;
    }

    brandTermsActions.setBrandVoiceIdsForBrandTerms(brandVoicesIds.all);
  }, [brandTermsActions, loadingBrandVoiceAssets, brandVoicesAssets]);
};
